module.exports = __webpack_public_path__ + "img/dashboard-graphic2.4b24ae7f.png";